<template>
  <v-container
    style="position:absolute;left:50%;transform:translateX(-50%);"
    class="d-flex flex-column justify-center align-center"
  >
    {{ values.schritt }} / {{ values.anzahlSchritte }}
    <h1>
      {{ texte.titel }}
    </h1>
    <p class="pa-6">
      {{ texte.frage }}
    </p>
    <v-slide-group
      v-model="value"
      class="px-0"
      active-class="success"
      :show-arrows="$vuetify.breakpoint.smAndUp"
      :center-active="true"
      :multiple="allowMultiple"
    >
      <v-slide-item
        v-for="n in items"
        :key="n.id"
        v-slot="{ active, toggle }"
        :value="n.id"
      >
        <v-card
          class="ma-2"
          height="auto"
          :class="{
            'back lighten-1': !active,
            'success': active,
            'width300px': !$vuetify.breakpoint.xs,
            'width200px': $vuetify.breakpoint.xs
          }"
          @click="toggle"
        >
          <!--
          <v-dialog
            v-model="dialog_info[n.id]"
            width="500"
            overlay-opacity="0.8"
            scrollable
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-2"
                style="position:absolute;z-index:1;right:0px;"
                color="red lighten-2"
                dark small
                v-bind="attrs"
                v-on="on"
              >
                ?
              </v-btn>
            </template>

            <v-card dark class="back">
              <v-card-title>
                Privacy Policy
              </v-card-title>

              <v-card-text>
                asd
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  @click="dialog_info[n.id] = false"
                >
                  OK
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          -->
          <v-row
            v-if="n.icon && n.icon !== ''"
            align="center"
          >
            <v-col align="center">
              <v-icon
                x-large
                class="ma-2"
              >
                {{ n.icon }}
              </v-icon>
            </v-col>
          </v-row>
          <v-row
            v-if="n.iconfont_font && n.iconfont_font !== ''"
            align="center"
          >
            <v-col align="center"
            v-html="n.iconfont_icon"
            :style="{
              fontFamily: n.iconfont_font,
              fontSize: '300%',
            }"
            class="pt-6"
            />
          </v-row>
          <v-img
            v-if="n.img && n.img !== ''"
            :src="n.img"
            aspect-ratio="1.7"
            class="mb-2"
          >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <v-card-title>
            <div
              v-html="spansNoWrap(n.name)"
            />
          </v-card-title>
          <v-card-text>
            <p align="left" v-html="n.beschreibung"></p>
            <p align="left" v-html="n.htmlAttribute"></p>
            <p
              v-if="n.preis"
              class="ma-0"
              align="right"
            >
              {{ n.preis.toLocaleString("de-DE", {style:"currency", currency:"EUR"}) }}
            </p>
            <v-scale-transition>
              <v-icon
                style="position:absolute;right:-15px;bottom:-15px;"
                v-if="active"
                color="white"
                size="48"
                v-text="'mdi-checkbox-marked-circle-outline'"
              ></v-icon>
            </v-scale-transition>
          </v-card-text>
        </v-card>
      </v-slide-item>
    </v-slide-group>
    <div>
      <v-btn
        class="ma-2"
        v-if="back"
        @click="
          $emit('back');
        "
      >
        Zurück
      </v-btn>
      <v-scale-transition>
        <v-btn
          class="ma-2"
          color="primary"
          v-if="
            (
              !allowMultiple
              && value > 0
            )
            || (
              allowMultiple
              && value.length > 0
            )
            || allowNone
          "
          @click="
            $emit('change', [value]);
          "
        >
          Weiter
        </v-btn>
      </v-scale-transition>
    </div>
    <Impressum />
  </v-container>
</template>

<script>
import Impressum from '@/components/Impressum.vue';

export default {
  name: 'BuchungSelect',
  components: {
    Impressum,
  },
  props: {
    query: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default() { return []; },
    },
    values: {
      type: Object,
      default() { return {}; },
    },
    texte: {
      type: Object,
      default() {
        return {
          titel: 'Titel',
          frage: 'Lorem ipsum dolor sit amet.',
        };
      },
    },
    back: {
      type: Boolean,
      default: false,
    },
    prop_value: {
      type: Array,
      default() { return []; },
    },
    allowMultiple: {
      type: Boolean,
      default: false,
    },
    allowNone: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dialog_info: {},
    value: 0,
  }),
  methods: {
    spansNoWrap(string) {
      let title = string;
      title = title.split(' ').join('</span> <span style="white-space:nowrap;">');
      title = title.split('&shy;').join('</span>- <span style="white-space:nowrap;">');
      return `
        <span style="white-space:nowrap;">
          ${title}
        </span>
      `;
    },
  },
  created() {
    if (!this.allowMultiple) {
      [this.value] = this.prop_value;
    } else {
      this.value = [];
      // console.log(this.prop_value);
      if (this.prop_value[0]) {
        this.prop_value[0].forEach((v) => {
          this.value.push(v);
        });
      }
      // console.log(this.value);
    }
    /* if (
      this.query === 'fzga'
      && this.$router.history.current.query.fzg
    ) {
      const idFahrzeug = parseInt(this.$router.history.current.query.fzg, 10);
      if (
        this.values.fahrzeug
          .filter((o) => o.id === idFahrzeug)
          .length > 0
      ) {
        this.values.fahrzeugart = [
          this.value = this.items
            .filter((o) => o.id === idFahrzeug)[0].,
        ];
      }
    } */
    /* if (
      this.query === 'pkt'
      && this.$router.history.current.query.pkt
    ) {
      let idPaket = parseInt(this.$router.history.current.query.pkt, 10);
      idPaket = idPaket.split('-');
      idPaket.forEach((p) => {
        if (
          this.data.pakete
            .filter((o) => o.id === p)
            .length > 0
          && !this.values.pakete[0]
            .includes(p)
        ) {
          this.values.pakete[0].push(idPaket);
        }
      });
    } */
  },
};
</script>
<style scoped>
  .width300px {
    width:300px;
  }
  .width200px {
    width:220px;
  }
</style>
